const LOCAL_HOSTNAMES = new Set(['localhost', '127.0.0.1', '[::1]']);
const DEVELOPMENT_SITE_PATTERN =
    /^(alphaapp|betaapp|stagingapp|testapp|alpha|beta|staging|deliveroobeta|[a-z0-9-]+dev)(?:\.|$)/i;

export const getDevelopmentSiteName = (
    hostname: string = window.location.hostname
): string | null => {
    const normalizedHostname = hostname.replace(/^www\./i, '').toLowerCase();

    if (
        LOCAL_HOSTNAMES.has(normalizedHostname) ||
        normalizedHostname.startsWith('localhost.')
    ) {
        return 'localhost';
    }

    if (!DEVELOPMENT_SITE_PATTERN.test(normalizedHostname)) {
        return null;
    }

    return normalizedHostname.split('.')[0];
};
